import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  BootState,
  deferAfterFirstPaint,
  listenForBootMessages,
  loadBootState,
  updateBootState,
} from './boot-state';

@Injectable({ providedIn: 'root' })
export class BootStateService {
  private readonly bootSubject = new BehaviorSubject<BootState>(loadBootState());
  readonly boot$ = this.bootSubject.asObservable();
  private unsubscribeBootMessages: (() => void) | null = null;

  constructor() {
    this.unsubscribeBootMessages = listenForBootMessages((boot) => {
      this.bootSubject.next(boot);
    });
  }

  get snapshot(): BootState {
    return this.bootSubject.value;
  }

  patch(partial: Partial<BootState>): BootState {
    const next = updateBootState(partial);
    this.bootSubject.next(next);
    return next;
  }

  runAfterFirstPaint(task: () => void): void {
    deferAfterFirstPaint(task);
  }
}
